// extracted by mini-css-extract-plugin
export default {"ExpiredContacts":"ExpiredContacts_ExpiredContacts__xltFm","ExpiredContactsPaper":"ExpiredContacts_ExpiredContactsPaper__tmYQz","header":"ExpiredContacts_header__QOQQ3"};